export default __webpack_public_path__ + "resources/icons/n311-5b2d.png";